import type {Reactions} from 'shells/timeline/reaction-bar/types';

import type {ReactionType} from 'nutshell-graphql-types';
import type {SessionUser} from 'nutshell-graphql-types';

import {getToggleAction} from '../../../timeline/reactions/helpers';

import {useCreateReaction} from './use-create-reaction';
import {useDeleteReaction} from './use-delete-reaction';

export function useToggleReaction(): (arg1: {
    changeLogId: string;
    reactionType: ReactionType;
    reactions: Reactions;
    user: SessionUser;
    activityId: string;
}) => Promise<any> {
    const createReaction = useCreateReaction();
    const deleteReaction = useDeleteReaction();

    return (toggleReactionInput: {
        changeLogId: string;
        reactionType: ReactionType;
        reactions: Reactions;
        user: SessionUser;
        activityId: string;
    }) => {
        const {changeLogId, reactionType, user, activityId, reactions} = toggleReactionInput;

        const toggleAction = getToggleAction(reactionType, reactions, user.id);

        return toggleAction === 'create'
            ? createReaction({changeLogId, reactionType, user, activityId})
            : deleteReaction({changeLogId, reactionType, user, activityId});
    };
}
